@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <div class="date-time-input-field fx-row fx-justify-start fx-items-center">
      <mat-form-field [appearance]='inputService.inputConfig.appearence' [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'>
        <mat-label>
          @if (inputService.formInputDefinition.titleIcon) {
            <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
          }
          <span>{{inputService.computedTitle | translate}}</span>
        </mat-label>
        @if (inputService.inputConfig.readOnly) {
          <input readonly matInput
            [formControlName]='inputService.formControlKey'
            [matDatepickerFilter]="dateFilterBinded"
            [matDatepicker]="dp3" >
        }
        @if (!inputService.inputConfig.readOnly) {
          <input
            [required]='inputService.inputConfig.required'
            matInput
            [matDatepicker]="dp3"
            [placeholder]="inputService.inputConfig.placeholder | translate"
            (click)='dp3.open()'
            [formControlName]='inputService.formControlKey' readonly>
        }
        @if (!inputService.inputConfig.readOnly) {
          <mat-datepicker-toggle matSuffix [for]="dp3">
            <mat-icon matDatepickerToggleIcon>event</mat-icon>
          </mat-datepicker-toggle>
        }
        <mat-datepicker #dp3></mat-datepicker>
        @if (!inputService.control.valid && inputService.errorMessage) {
          <mat-error>{{inputService.errorMessage | translate}}</mat-error>
        }
      </mat-form-field>
      <div class='time-form-field' [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'>
        @if (inputService.control.value) {
          <input [readonly]='inputService.inputConfig.readOnly' autocomplete="off" type='time' [value]='initialTimeValue' (change)='onTimeChanged($event)'>
        }
      </div>
    </div>
  </ng-container>
}